<script>
import { healthVaultService } from '@/src/services/safehaven/HealthVaultService'
import { formatDateMoment } from '@utils/format-date'
import RevokeConfirmationDialog from '@/src/components/revoke-confirmation-dialog.vue'
export default {
  components: { RevokeConfirmationDialog },
  data() {
    return {
      revokeDialog: false,
      selected: '',
      headers: [
        {
          text: 'Document name',
          align: 'start',
          value: 'document_name',
          sortable: false,
          class: 'my-header-style',
        },
        {
          text: 'Recipient',
          value: 'recipient_name',
          sortable: false,
          class: 'my-header-style',
        },
        {
          text: 'Expiration Date',
          value: 'expiry_date',
          sortable: false,
          class: 'my-header-style',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          class: 'my-header-style',
        },
      ],
      sharedDoc: [],
      options: {},
      timeout: null,
      totalRecord: 0,
      totalPages: 0,
      filterDetails: {
        page_count: 1,
      },
    }
  },
  async mounted() {
    this.getAllSharedRecords()
  },
  methods: {
    formatDateMoment,
    revokePopup(item) {
      this.selected = item
      this.revokeDialog = true
    },
    closeRevokeDialog(action) {
      if (action === 'yes') {
        this.revokeDialog = false
        var obj = {
          document_id: this.selected.document_id,
          is_access_revoked: true,
          recipient_id: this.selected.recipient_id,
        }

        healthVaultService.revokeDocument(obj).then((res) => {
          if (res) {
            this.selected = null
            this.updateData()
          }
        })
      } else {
        this.revokeDialog = false
        this.selected = null
      }
    },
    updateData() {
      this.filterDetails = {
        page_count: 1,
      }
      this.sharedDoc = []
      this.getAllSharedRecords()
    },
    getAllSharedRecords() {
      this.loading = true
      healthVaultService.getSharedDocument(this.filterDetails).then((res) => {
        if (!this.sharedDoc.length) {
          this.totalRecord = res.data.number_of_records
          this.totalPages = Math.ceil(this.totalRecord / 10)
          this.sharedDoc = res.data.records
        } else {
          this.sharedDoc = this.sharedDoc.concat(res.data.records)
        }
      })
    },
    onScroll(e) {
      if (this.filterDetails.page_count < this.totalPages) {
        this.timeout && clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          this.filterDetails.page_count = this.filterDetails.page_count + 1
          const { scrollTop } = e.target
          this.getAllSharedRecords()

          this.$nextTick(() => {
            e.target.scrollTop = scrollTop
          })
        }, 500)
      }
    },
  },
}
</script>

<template>
  <v-row
    no-gutters
    class="my-auto"
    :class="[$vuetify.breakpoint.mobile ? 'pr-1' : 'pr-10']"
  >
    <v-col cols="12" md="12" sm="12" lg="12" xl="12">
      <v-data-table
        id="virtual-scroll-table-list"
        v-scroll:#virtual-scroll-table-list="onScroll"
        :class="[
          $style.sharedDocTable,
          [$vuetify.breakpoint.mobile ? 'pt-4' : ''],
        ]"
        class="mt-4"
        :headers="headers"
        :items="sharedDoc"
        :hide-default-footer="true"
        disable-pagination
      >
        <template v-slot:[`item.document_name`]="{ item }">
          <div
            :class="[
              item.is_access_revoked || item.is_deleted || item.is_expired
                ? $style.strikeThrough
                : '',
            ]"
          >
            {{ item.document_name }}
          </div>
        </template>
        <template v-slot:[`item.recipient_name`]="{ item }">
          <div
            :class="[
              item.is_access_revoked || item.is_deleted || item.is_expired
                ? $style.strikeThrough
                : '',
            ]"
          >
            {{ item.recipient_name }}
          </div>
        </template>
        <template v-slot:[`item.expiry_date`]="{ item }">
          <div
            :class="[
              (item.is_access_revoked || item.is_deleted || item.is_expired) &&
              item.expiry_date
                ? $style.strikeThrough
                : '',
            ]"
          >
            {{
              item.expiry_date
                ? formatDateMoment(item.expiry_date, 'MM/DD/YYYY')
                : '--'
            }}
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            v-if="item.is_access_revoked"
            class="text-capitalize"
            text
            color="error"
          >
            Revoked
          </v-btn>
          <v-btn
            v-else-if="item.is_deleted"
            class="text-capitalize"
            text
            color="error"
          >
            Deleted
          </v-btn>
          <v-btn
            v-else-if="item.is_expired"
            class="text-capitalize"
            text
            color="error"
          >
            Expired
          </v-btn>

          <v-btn
            v-else
            class="ma-2 text-capitalize"
            rounded
            outlined
            color="indigo"
            @click="revokePopup(item)"
          >
            Revoke
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <RevokeConfirmationDialog
      v-if="selected"
      :dialog="revokeDialog"
      :item="selected"
      :is-health-vault="true"
      @closeRevokeDialog="closeRevokeDialog"
    ></RevokeConfirmationDialog>

    <button id="updateGetAllData" hidden @click="updateData"></button>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';
.sharedDocTable {
  padding: 0 15px 10px;
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}
.my-header-style,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 11px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 15px;
  color: #aaa !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}

.sharedDocTableBody tr td {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  color: #454648 !important;
  letter-spacing: 0.15px;
}
.sharedDocTableFont {
  font-weight: 600;
  color: #454648 !important;
  text-decoration: none;
}
.buttonTextBold {
  font-weight: bold !important;
}

tbody {
  tr:hover {
    background-color: #f2f9ff !important;
  }
}

.strikeThrough {
  text-decoration: line-through;
  text-decoration-color: #6e6d6d;
}
</style>

<style scoped>
/deep/ .v-data-table__wrapper thead.v-data-table-header tr th.sortable span {
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  color: #aaa !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
/deep/ .theme--light.v-data-table {
  min-height: 100px !important;
  max-height: 400px !important;
  overflow: auto !important;
}
</style>
